import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import jsDig from "utils/jsDig";
import { capitalize } from "lodash";
import showAlert from 'utils/showAlert';
import { event } from "jquery";
import CustomTooltip from "utils/CustomTooltip";

export default function Reports(props) {
  const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;
  const [show, setShow] = useState(false);

  const [newReport, setNewReport] = useState({
    id: "",
    dashboard: "",
    platforms: "",
    dimensions: "",
    metrics: "",
    daterange: "",
    google_sheets_url: "",
    refresh_daily: false,
    sheet_name: "",
    target_cell: "",
  });
  const [selectedReport, setSelectedReport] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const createNewReport = (event) => {
    event.preventDefault();
    // Sends post request to /reports/create-report
    fetch('/datapulse/reports/create-report', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': authenticityToken,
      },
      body: JSON.stringify({
        new_report: newReport,
        account_id: props.selected_account.id
      }),
    })
      .then(response => response.json())
      .then(data => {
        showAlert('New report created successfully!');
        handleClose();
        window.location.reload();
      })
      .catch(error => {
        showAlert('Error creating report. Please try again.', 'danger');
        console.error('Error:', error);
      });
  };
  
  const saveReport = (event) => {
    event.preventDefault();
    // Sends post request to /reports/save-report
    fetch('/datapulse/reports/save-report', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': authenticityToken,
      },
      body: JSON.stringify({
        report: selectedReport,
        account_id: props.selected_account.id
      }),
    })
      .then(response => response.json())
      .then(data => {
        showAlert('Report saved successfully!');
        handleClose();
        window.location.reload();
      })
      .catch(error => {
        showAlert('Error saving report. Please try again.', 'danger');
        console.error('Error:', error);
      });
  }
  
  const exportReport = (event) => {
    event.preventDefault();
    // Sends post request to /reports/export-to-google-sheets
    fetch('/datapulse/reports/export-to-google-sheets', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': authenticityToken,
      },
      body: JSON.stringify({ report_id: selectedReport.id }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          handleClose();
          showAlert('Report exported to Google Sheets successfully!');
        } else {
          handleClose();
          showAlert(`Error exporting report. ${data.message}`, 'danger');
        }
      })
      .catch(error => {
        showAlert('Error exporting report. Please try again.', 'danger');
        console.error('Error:', error);
      });
  }
  
  const deleteReport = (event) => {
    event.preventDefault();
    // Sends post request to /reports/delete-report
    fetch('/datapulse/reports/delete-report', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': authenticityToken,
      },
      body: JSON.stringify({ report_id: selectedReport.id }),
    })
      .then(response => response.json())
      .then(data => {
        showAlert('Report deleted successfully!');
        handleClose();
        window.location.reload();
      })
      .catch(error => {
        showAlert('Error deleting report. Please try again.', 'danger');
        console.error('Error:', error);
      });
  }

  const openReport = (id) => {
    const report = props.export_reports.find(report => report.id === id);
    setSelectedReport(report);
    handleShow();
  }


  return (
    <>
      <div className="export-reports-container standard-page-padding">
        <div className="export-reports-header">
          <h1>Export Reports</h1>
          <p className="mb-5">Use this tool to automate sending data from DataPulse dashboards to Google Sheets.</p>
        </div>
        <div className="export-reports-body">
          {props.export_reports && props.export_reports.map((report) => (
            <div className="export-report" key={report.id} onClick={() => openReport(report.id)} style={{ cursor: "pointer", alignItems: "center" }}>
              <h4>{report.dashboard && report.dashboard != "" ? report.dashboard : "Not configured"}</h4>
              <p>{report.platforms}</p>
            </div>
          ))}
        </div>
        <button className="button b-type-primary b-size-normal" onClick={createNewReport}>New Report</button>
      </div>

      <Modal className="lite-modal-2 export-reports-modal" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h4>Report</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex gap-24">
            <div className="d-flex flex-column w-100">
              <div className="lite-form-group mb-3">
                <label className="input-label" htmlFor="dashboard">Dashboard</label>
                <small className="mb-2">Options:
                <CustomTooltip
                  faClass="far fa-question-circle pl-2"
                  message="overview, paid_social, paid_search, organic_social, organic_search, email, amazon, other"
                  inline={true}
                  bold={true}
                />
                </small>
                <input className="lite-input" type="text" id="dashboard" name="dashboard" value={selectedReport ? selectedReport.dashboard : ""} onChange={(e) => setSelectedReport({ ...selectedReport, dashboard: e.target.value })} />
              </div>
              <div className="lite-form-group mb-3">
                <label className="input-label" htmlFor="platforms">Platforms</label>
                <small>Options:
                  <CustomTooltip
                    faClass="far fa-question-circle pl-2"
                    message="google_analytics, google_ads, microsoft_ads, facebook_ads, tiktok_ads, pinterest_ads, youtube, semrush, amazon_ads, amazon_seller, mailchimp, klaviyo"
                    inline={true}
                    bold={true}
                  />
                </small>
                <input className="lite-input" type="text" id="platforms" name="platforms" value={selectedReport ? selectedReport.platforms : ""} onChange={(e) => setSelectedReport({ ...selectedReport, platforms: e.target.value })} />
              </div>
              <div className="lite-form-group mb-3">
                <label className="input-label" htmlFor="daterange">Date Range</label>
                <small>Options:
                  <CustomTooltip
                    faClass="far fa-question-circle pl-2"
                    paragraphs={[
                      "last_7_days, last_14_days, last_30_days, last_60_days, last_90_days, this_year, last_year, last_year_to_date, 2_years_ago_to_date",
                      "Custom: YYYY-MM-DD,YYYY-MM-DD"
                    ]}
                    inline={true}
                    bold={true}
                  />
                </small>
                <input className="lite-input" type="text" id="daterange" name="daterange" value={selectedReport ? selectedReport.daterange : ""} onChange={(e) => setSelectedReport({ ...selectedReport, daterange: e.target.value })} />
              </div>
              <div className="lite-form-group mb-3">
                <label className="input-label" htmlFor="refresh_daily">Refresh Daily</label>
                <input style={{width: "20px"}} className="lite-input" id="refresh_daily" name="refresh_daily" type="checkbox" checked={selectedReport ? selectedReport.refresh_daily : ""} onChange={(e) => setSelectedReport({ ...selectedReport, refresh_daily: e.target.checked })} />
              </div>
            </div>
            <div className="d-flex flex-column w-100">
              <div className="lite-form-group mb-3">
                <label className="input-label" htmlFor="dimensions">Dimensions</label>
                <small>Options:
                  <CustomTooltip
                    faClass="far fa-question-circle pl-2"
                    message="date"
                    inline={true}
                    bold={true}
                  />
                </small>
                {/* <input className="lite-input" type="text" id="dimensions" name="dimensions" value={selectedReport ? selectedReport.dimensions : ""} onChange={(e) => setSelectedReport({ ...selectedReport, dimensions: e.target.value })} /> */}
                <input className="lite-input disabled" type="text" id="daterange" name="daterange" value={"date"} disabled />
              </div>
              <div className="lite-form-group mb-3">
                <label className="input-label" htmlFor="metrics">Metrics</label>
                <small>Options:
                  <CustomTooltip
                    faClass="far fa-question-circle pl-2"
                    message="spend, clicks, conversions, revenue, roas, cpa, frequency, mer, conversion_rate, sessions, open_rate, ctr, bounce_rate, email_list_growth, impressions, reach, new_customers, aov, bounces, opens"
                    inline={true}
                    bold={true}
                  />
                </small>
                <input className="lite-input" type="text" id="metrics" name="metrics" value={selectedReport ? selectedReport.metrics : ""} onChange={(e) => setSelectedReport({ ...selectedReport, metrics: e.target.value })} />
              </div>
              <div className="lite-form-group mb-3">
                <label className="input-label" htmlFor="target_cell">Target Cell</label>
                <small>Format: <b>SheetName!A1</b></small>
                <input className="lite-input" type="text" id="target_cell" name="target_cell" value={selectedReport ? selectedReport.target_cell : ""} onChange={(e) => setSelectedReport({ ...selectedReport, target_cell: e.target.value })} />
              </div>
            </div>
          </div>

          <div className="lite-form-group mb-3">
            <label className="input-label" htmlFor="google_sheets_url">Google Sheets URL</label>
            <input className="lite-input" type="text" id="google_sheets_url" name="google_sheets_url" value={selectedReport ? selectedReport.google_sheets_url : ""} onChange={(e) => setSelectedReport({ ...selectedReport, google_sheets_url: e.target.value })} />
          </div>

          <div>
            <div className="d-flex justify-content-end mt-3 gap-12">
              <button className="button b-type-secondary b-size-small b-color-red" onClick={deleteReport}>Delete</button>
              <button className="button b-type-primary b-size-small" onClick={saveReport}>Save</button>
              <button className="button b-type-primary b-size-small b-color-green" onClick={exportReport}>Export</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}